export default __webpack_public_path__ + "static/media/guiavet.71106ecf.png";